//import firebase from "./firebase"
import React from "react";
const firebase = require("firebase");
require("firebase/firestore");
require("firebase/firestore");

class Permiso extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      respuesta: false
      // deCanela2: "ghghghghg"
    };
  }

  Permiso = callback => {
    const user = firebase.auth().currentUser;
    if (user != null) {
      //console.log(user.displayName);
      // console.log(user.email);
      //console.log(user.photoURL);
      //console.log(user.emailVerified);
      //console.log(user.uid);
    }
    firebase
      .firestore()
      .collection("usuarios")
      .where("email", "==", user.email)
      .onSnapshot(serverUpdate => {
        const rolCliente = serverUpdate.docs.map(_doc => {
          const data = _doc.data();
          data["id"] = _doc.id;
          return data;
        });

        firebase
          .firestore()
          .collection("rol")
          .where("id", "==", rolCliente[0].rol)
          .onSnapshot(serverUpdate => {
            const deCanela = serverUpdate.docs.map(_doc => {
              const data = _doc.data();
              data["id"] = _doc.id;
              return data;
            });

            callback(deCanela[0], rolCliente[0]);
          });
      });

    // console.log(per, "antes del return en permiso/ permiso.js");
    //console.log(this.state.respuesta, "el estado RESPUESTA");
    //console.log(this.state.deCanela2, "el estado RESPUESTA");
    // return per;
  };
}

export default Permiso;
